import React from 'react';
// import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import { CopyToClipboard } from 'react-copy-to-clipboard';

// Utils
import { validateEmail } from '../../helpers/utils';

// Actions
import { gameActions } from '../../actions';

import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Header from '../../components/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDotCircle } from '@fortawesome/free-solid-svg-icons';
// import Reopen from '../../components/Reopen';
import List from './list';
import AddPlayer from './add_player';

// const statusLabels = {
//   init: 'Ongoing',
//   deal: 'Deal',
//   nodeal: 'Abandoned',
// };

class Players extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: this.props.item || null,
      pair_modal: false,
      new_players: [],
      copied: false,
    };

    // Bindings
    this.addPairModal = this.addPairModal.bind(this);
    this.handleNewPlayers = this.handleNewPlayers.bind(this);
    this.submitNewPlayers = this.submitNewPlayers.bind(this);
    this.isOnline = this.isOnline.bind(this);
  }

  componentDidMount() {
    const { dispatch, match, game } = this.props;
    if (match.params.id && !game?.data?._id) {
      dispatch(gameActions.fetchGames(match.params.id));
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      item: newProps.item,
    });
  }

  addPairModal() {
    this.setState({ pair_modal: !this.state.pair_modal, new_players: [] });
  }

  handleNewPlayers(newPlayers) {
    this.setState({ new_players: newPlayers });
  }

  submitNewPlayers() {
    const { game } = this.props;
    this.props.dispatch(
      gameActions.addPlayers(game.data._id, this.state.new_players)
    );
    this.addPairModal();
    this.setState({ new_players: [] });
  }

  isOnline(player) {
    const { game } = this.props;
    return game?.data?.online?.includes(player?.email) ? true : false;
  }

  render() {
    const { user, game } = this.props;
    const { copied } = this.state;

    let players = game.data.players || [];
    const groups = game.data.groups || [];

    players = players.map((p, pi) => {
      // Clone the player object
      const new_player = { ...p };

      const gindex = groups.findIndex((g) =>
        g.players.find((gp) => gp._id === new_player._id)
      );

      const groupName = groups[gindex] ? groups[gindex].name : null;
      new_player.group = groupName || 'Group ' + (1 + gindex);
      new_player.last_activity =
        new_player.last_activity !== null
          ? new Date(new_player.last_activity).toLocaleString()
          : 'None';

      const ml =
        process.env.REACT_APP_GAME_URL +
        '?i=' +
        new_player.game_id +
        '&e=' +
        new_player.email + // Encode this string to accept special characters?
        '&t=' +
        new_player.token +
        '&k=1';

      new_player.magiclink =
        user?.from !== 'lti-hbp' ? (
          <a
            href={ml}
            target='_blank'
            rel='noopener noreferrer'
            className='small'>
            <code style={{ maxWidth: '100px' }}>{ml}</code>
          </a>
        ) : (
          'N/A'
        );

      new_player.online = this.isOnline(new_player) ? (
        <FontAwesomeIcon
          icon={faDotCircle}
          title='Online'
          className={'text-success'}
        />
      ) : (
        <FontAwesomeIcon
          icon={faDotCircle}
          title='Offline'
          className={'text-secondary opacity-50'}
        />
      );

      return new_player;
    });

    // Validate that all the players have a valid email
    const validNewPlayers =
      this.state.new_players.length === 0
        ? false
        : this.state.new_players.every((pl) => {
            return validateEmail(pl.email);
          });
    // Validate if there are repeated players
    const repeatedPlayers = this.state.new_players.filter((pl, pli) => {
      return (
        players.find((p) => p.email === pl.email) ||
        this.state.new_players.find(
          (p, pi) => p.email === pl.email && pli !== pi
        )
      );
    });

    return (
      <div>
        <Header />

        <h2 className='mt-3 sec-title fs-3'>
          Player Management{' '}
          <small
            className='badge bg-pill bg-success'
            style={{
              fontSize: '12px',
              padding: '5px 8px',
              verticalAlign: 'middle',
            }}>
            {players.length} players
          </small>
          {game.data && (
            <small className='ms-3 me-auto'>
              <span
                className='badge bg-pill bg-dark mt-0'
                style={{
                  fontSize: '1rem',
                  padding: '5px 0px 0px 0px',
                  verticalAlign: 'middle',
                }}>
                <span
                  style={{ marginTop: '-5px', padding: '10px 10px' }}
                  className='badge bg-secondary bg-pill'>
                  Sign-up
                </span>
                <code className='text-white ms-2 me-2'>
                  {game.data.short_url}
                </code>
                <CopyToClipboard
                  text={game.data.short_url}
                  onCopy={() => this.setState({ copied: true })}>
                  <span
                    style={{
                      marginTop: '-5px',
                      padding: '10px 10px',
                      cursor: 'pointer',
                    }}
                    className='badge bg-primary bg-pill'>
                    {copied ? 'Copied' : 'Copy link'}
                  </span>
                </CopyToClipboard>
              </span>
            </small>
          )}
          <small className='float-end'>
            {user?.from !== 'lti-hbp' && (
              <button
                className='btn btn-outline-primary'
                onClick={this.addPairModal}>
                Add Player
              </button>
            )}
            <button
              className='btn btn-outline-primary ms-3'
              onClick={(e) => window.location.reload()}>
              <FontAwesomeIcon icon='redo-alt' className='me-1' size='sm' />{' '}
              Refresh
            </button>
          </small>
        </h2>

        <div className='small'>
          <List
            labels={[
              'Online',
              'Name',
              'Surname',
              'Email',
              'Group',
              'Last Activity',
              'MagicLink',
            ]}
            fields={[
              'online',
              'name',
              'lastname',
              'email',
              'group',
              'last_activity',
              'magiclink',
            ]}
            data={players}
          />
        </div>

        <Modal
          isOpen={this.state.pair_modal}
          toggle={this.addPairModal}
          centered={true}
          size={'md'}>
          <ModalHeader>Add Player</ModalHeader>
          <ModalBody className='text-center'>
            <p>
              Enter the player information and click the <b>"Add"</b> button.
            </p>
            <AddPlayer onChange={this.handleNewPlayers} groups={groups} />
            {repeatedPlayers.length > 0 && (
              <div className='alert alert-danger mt-4'>
                The following players are already in this session:{' '}
                <b>{repeatedPlayers.map((p) => p.email).join(', ')}</b>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <button className='btn btn-light' onClick={this.addPairModal}>
              Cancel
            </button>
            <button
              className='btn btn-outline-primary'
              onClick={this.submitNewPlayers}
              disabled={!validNewPlayers || repeatedPlayers.length > 0}>
              Add
            </button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { player, game, authentication } = state;
  const { user } = authentication;
  return {
    user,
    game,
    player,
  };
}

const connectedPlayersPage = connect(mapStateToProps)(Players);
export { connectedPlayersPage as GamePlayers };
